<template>
  <lwf-autocomplete
    :value="value"
    :options="agencies"
    v-bind="vAttrs"
    v-on="vListeners"
  >
    <template #option="scope">
      <q-item
        v-ripple
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section>
          <q-item-label>
            {{ scope.opt.name }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template
      v-for="(slot, k) in $slots"
      #[k]
    >
      <slot :name="k" />
    </template>
    <template
      v-for="(slot, k) in $scopedSlots"
      #[k]="props"
    >
      <slot
        :name="k"
        v-bind="props"
      />
    </template>
  </lwf-autocomplete>
</template>

<script>
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import { plz } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import validateProxyMixin from '@/mixins/validateProxyMixin'

const storeUserAgency = createNamespacedHelpers('user/agency')
export default {
  name: 'AutocompleteAgency',
  components: { LwfAutocomplete },
  mixins: [validateProxyMixin],
  props: {
    value: {
      type: [String, Object, Array],
      default: undefined
    },
    multiple: Boolean,
    allToggle: Boolean
  },
  computed: {
    ...storeUserAgency.mapState({
      fetching: 'fetching',
      agencies: 'agencies'
    }),
    vListeners () {
      return {
        ...this.$listeners,
        ...this.vOn
      }
    },
    vAttrs () {
      const { multiple } = this
      return {
        label: plz('Agency', multiple),
        'hide-selected': !multiple,
        'use-chips': multiple,
        multiple,
        ...this.$attrs
      }
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
